import React from 'react';
import UFFTechLogo from '../../assets/img/Ut_junior_preta.png';
import './styles.css';
import {Link} from 'react-router-dom';

function Header() {
    return(
        <header>
            <section className="hd-legal">
                <ul className="hd-legal-list">
                    <li><img src = {UFFTechLogo} alt='Logo' id="logo"/></li>
                    <li><Link to = '/'>Home</Link ></li>
                    <li><Link to = '/fluxo-de-caixa'>Fluxo de Caixa</Link ></li>
                    <li><Link to = '/login'>Entrar</Link></li>
                </ul>
            </section>
        </header>
    );
}

export default Header;